import { ref } from 'vue'
import type { CartItem } from './cartBus'

export const deleteElementBasketBus = ref(false)
export const elementBasketBus = ref<CartItem>()
export const indexDeleteElement = ref()
